import { render, staticRenderFns } from "./item-bundle-chart.vue?vue&type=template&id=2d95bb86&scoped=true&"
import script from "./item-bundle-chart.vue?vue&type=script&lang=js&"
export * from "./item-bundle-chart.vue?vue&type=script&lang=js&"
import style0 from "./item-bundle-chart.vue?vue&type=style&index=0&id=2d95bb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95bb86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VCardTitle,VSelect})
